//@flow

import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  min-height: 300px;
  flex-basis: 300px;
  margin-left: 2rem;
  margin-right: 2rem;
`



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/LocationReport.js